/* Otraa — progressive enhancement only. The theme works with JS disabled. */

(function () {
  'use strict'

  // Locale bridge — emitted by theme.liquid from the locale files.
  const T = Object.assign(
    {
      addToBag: 'Add to bag', adding: 'Adding…', soldOut: 'Sold out',
      unavailable: 'Unavailable', remove: 'Remove',
      decrease: 'Decrease quantity', increase: 'Increase quantity',
      pickRating: 'Please pick a rating first.',
      reviewSent: 'Thanks — your review is with us.',
      reviewFailed: 'We could not send that. Please try again.',
      reviewNetwork: 'Network problem — your review was not sent.',
    },
    window.otraaT || {}
  )

  /* Mobile navigation ---------------------------------------------------- */
  const nav = document.querySelector('[data-nav]')
  const navToggles = document.querySelectorAll('[data-nav-toggle]')
  const navScrim = document.querySelector('[data-nav-scrim]')

  if (nav && navToggles.length) {
    const setNav = (open) => {
      nav.toggleAttribute('data-open', open)
      navToggles.forEach((t) => t.setAttribute('aria-expanded', String(open)))
      if (navScrim) navScrim.toggleAttribute('data-open', open)
      // Only release the scroll lock if no other overlay still wants it.
      const drawerOpen = document.querySelector('[data-cart-drawer][data-open]')
      document.body.style.overflow = open || drawerOpen ? 'hidden' : ''
      if (open) nav.querySelector('a, button')?.focus()
    }

    // querySelector caught only the burger, so the close button inside the
    // drawer was inert and the sidebar could be opened but never shut.
    navToggles.forEach((t) =>
      t.addEventListener('click', (e) => {
        e.preventDefault()
        setNav(!nav.hasAttribute('data-open'))
      })
    )

    navScrim?.addEventListener('click', () => setNav(false))

    // Following a link should not leave the drawer open behind the new page.
    nav.addEventListener('click', (e) => {
      if (e.target.closest('a')) setNav(false)
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.hasAttribute('data-open')) setNav(false)
    })

    // Resizing past the breakpoint must not leave a stuck scroll lock.
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990 && nav.hasAttribute('data-open')) setNav(false)
    })
  }

  /* Collection sort — submit on change so no "Apply" button is needed ----- */
  document.querySelectorAll('[data-auto-submit]').forEach((el) => {
    el.addEventListener('change', () => el.form.submit())
  })

  /* Accordions: keep only one panel open per group ------------------------ */
  document.querySelectorAll('[data-accordion-exclusive]').forEach((group) => {
    const items = group.querySelectorAll('details')
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return
        items.forEach((other) => {
          if (other !== item) other.open = false
        })
      })
    })
  })

  /* Header shadow once the page scrolls ---------------------------------- */
  const header = document.querySelector('[data-header]')
  if (header) {
    const onScroll = () => header.toggleAttribute('data-scrolled', window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  }

  /* Live search ----------------------------------------------------------- */
  /* Client-side engine over assets/search-index.json (~9kB, 36 products):
     tri-lingual synonyms and typo tolerance that Search & Discovery would not
     give a store this size. The Section Rendering API path stays as fallback
     when the index cannot load. */

  document.querySelectorAll('[data-quicksearch]').forEach((wrap) => {
    const input = wrap.querySelector('[data-quicksearch-input]')
    const panel = wrap.querySelector('[data-quicksearch-results]')
    if (!input || !panel) return

    let timer = null
    let controller = null
    let lastQuery = ''
    let index = null
    let indexFailed = false

    const locale = (document.documentElement.lang || 'en').slice(0, 2)
    const eur = new Intl.NumberFormat(locale, {
      style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
    })

    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false') }
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true') }

    const norm = (str) =>
      str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

    // de / sk / en vocabulary and common misspellings → catalogue vocabulary.
    // Each entry is an ALTERNATIVE for the typed word, never a requirement.
    const SYN = {
      handy: 'iphone', handys: 'iphone', smartphone: 'iphone', telefon: 'iphone',
      mobil: 'iphone', mobilny: 'iphone', apfel: 'apple',
      ifone: 'iphone', iphon: 'iphone', ipone: 'iphone', aifon: 'iphone', ajfon: 'iphone',
      laptop: 'macbook', notebook: 'macbook', prenosny: 'macbook',
      makbook: 'macbook', makbuk: 'macbook', macbok: 'macbook',
      rechner: 'mac', computer: 'mac', pocitac: 'mac',
      bildschirm: 'imac', desktop: 'imac mini studio',
      speicher: 'gb', pamat: 'gb',
      akku: 'battery', bateria: 'battery',
    }

    const dist = (a, b, max) => {
      if (Math.abs(a.length - b.length) > max) return max + 1
      let prev = [...Array(b.length + 1).keys()]
      for (let i = 1; i <= a.length; i++) {
        const cur = [i]
        let best = i
        for (let j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1))
          best = Math.min(best, cur[j])
        }
        if (best > max) return max + 1
        prev = cur
      }
      return prev[b.length]
    }

    const tokenMatch = (qt, word) => {
      if (word.startsWith(qt)) return qt.length === word.length ? 3 : 2.5
      if (qt.length >= 4) {
        const budget = qt.length >= 7 ? 2 : 1
        if (dist(qt, word.slice(0, qt.length + budget), budget) <= budget) return 1.5
      }
      return 0
    }

    function searchClient(query) {
      // Each typed word becomes a GROUP of alternatives (itself + synonyms).
      // A product must satisfy every group via any one alternative — treating
      // synonyms as extra requirements instead used to kill "Handy" outright.
      // "under 500", "unter 400€", "do 300", "bis 600" → price ceiling.
      let ceiling = null
      const priced = norm(query).replace(/(?:under|unter|bis|do|pod|max)\s*€?\s*(\d{2,5})\s*€?/, (_, n) => {
        ceiling = Number(n)
        return ' '
      })

      const groups = priced.split(/\s+/).filter(Boolean)
        .map((t) => (SYN[t] ? [t, ...SYN[t].split(' ')] : [t]))
      if (!groups.length && !ceiling) return { products: [], pages: [] }

      // Pure price query: cheapest matches, nothing else to score.
      if (!groups.length) {
        return {
          products: index.products.filter((x) => x.p <= ceiling).sort((a, b) => a.p - b.p).slice(0, 6),
          pages: [],
        }
      }

      const scored = []
      for (const item of index.products) {
        const title = norm(item.t).split(/\s+/)
        const hay = item.k.split(/\s+/)
        let total = 0
        let ok = true
        for (const alts of groups) {
          let best = 0
          for (const qt of alts) {
            for (const w of title) best = Math.max(best, tokenMatch(qt, w) * 1.4)
            for (const w of hay) best = Math.max(best, tokenMatch(qt, w))
          }
          if (!best) { ok = false; break }
          total += best
        }
        if (ok && (!ceiling || item.p <= ceiling)) scored.push([total, item])
      }
      scored.sort((a, b) => b[0] - a[0] || a[1].p - b[1].p)

      const pages = index.pages
        .map((pg) => ({ u: pg.u, t: pg.t[locale] || pg.t.en }))
        .filter((pg) =>
          groups.some((alts) =>
            alts.some((qt) => norm(pg.t).split(/\s+/).some((w) => tokenMatch(qt, w) >= 2))
          )
        )
        .slice(0, 3)

      return { products: scored.slice(0, 6).map((x) => x[1]), pages }
    }

    function renderClient({ products, pages }, query) {
      if (!products.length && !pages.length) {
        panel.innerHTML = '<p class="qs__empty small muted">' +
          ((window.otraaT && window.otraaT.noMatch) || 'No matches. Try a model name.') + '</p>'
        open(); return
      }
      let html = ''
      if (products.length) {
        html += '<ul class="qs__list" role="listbox">' + products.map((p) => `
          <li role="option"><a class="qs__item" href="${p.u}">
            <span class="qs__media">${p.i ? `<img src="${p.i}" alt="" width="48" height="48" loading="lazy">` : '<span class="ph" style="aspect-ratio:1/1"></span>'}</span>
            <span class="qs__text"><span class="qs__title">${p.t}</span></span>
            <span class="qs__price">${eur.format(p.p)}</span>
          </a></li>`).join('') + '</ul>'
      }
      if (pages.length) {
        html += '<div class="qs__group"><ul class="qs__list">' +
          pages.map((pg) => `<li><a class="qs__link" href="${pg.u}">${pg.t}</a></li>`).join('') +
          '</ul></div>'
      }
      html += `<a class="qs__all" href="/search?q=${encodeURIComponent(query)}">${
        (window.otraaT && window.otraaT.seeAll) || 'See all results'}</a>`
      panel.innerHTML = html
      open()
    }

    async function runServer(query) {
      controller?.abort()
      controller = new AbortController()
      const url =
        `${window.Shopify?.routes?.root || '/'}search/suggest` +
        `?q=${encodeURIComponent(query)}&resources[type]=product,page,article` +
        `&resources[limit]=6&section_id=predictive-search`
      try {
        const res = await fetch(url, { signal: controller.signal })
        if (!res.ok) throw new Error(res.status)
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html')
        const inner = doc.querySelector('.shopify-section')
        panel.innerHTML = inner ? inner.innerHTML : ''
        open()
      } catch (err) {
        if (err.name !== 'AbortError') close()
      }
    }

    async function run(query) {
      if (!index && !indexFailed && wrap.dataset.searchIndex) {
        try {
          const res = await fetch(wrap.dataset.searchIndex)
          index = await res.json()
        } catch {
          indexFailed = true
        }
      }
      if (index) renderClient(searchClient(query), query)
      else runServer(query)
    }

    input.addEventListener('input', () => {
      const query = input.value.trim()
      clearTimeout(timer)
      if (query.length < 2) { close(); return }
      if (query === lastQuery) return
      timer = setTimeout(() => { lastQuery = query; run(query) }, 120)
    })

    // Warm the index on focus so the first keystroke is instant.
    input.addEventListener('focus', () => {
      if (!index && !indexFailed && wrap.dataset.searchIndex) {
        fetch(wrap.dataset.searchIndex).then((r) => r.json()).then((d) => (index = d)).catch(() => (indexFailed = true))
      }
      if (panel.innerHTML.trim() && input.value.trim().length >= 2) open()
    })

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close()
    })

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { close(); input.blur(); return }
      if (panel.hidden) return
      const items = [...panel.querySelectorAll('.qs__item, .qs__link, .qs__all')]
      if (!items.length) return
      const current = items.findIndex((i) => i === document.activeElement)
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(current + 1, items.length - 1)].focus() }
      else if (e.key === 'ArrowUp') { e.preventDefault(); current <= 0 ? input.focus() : items[current - 1].focus() }
    })

    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { close(); input.focus() }
    })
  })

  /* Cart drawer ----------------------------------------------------------- */

  const drawer = document.querySelector('[data-cart-drawer]')

  if (drawer) {
    const body = drawer.querySelector('[data-cart-body]')
    const foot = drawer.querySelector('[data-cart-foot]')
    const empty = drawer.querySelector('[data-cart-empty]')
    const subtotal = drawer.querySelector('[data-cart-subtotal]')
    const countEl = drawer.querySelector('[data-cart-count]')
    const panel = drawer.querySelector('.drawer__panel')
    let lastFocus = null

    const fmt = (cents) => {
      const el = document.querySelector('[data-cart-subtotal]')
      const sample = el?.dataset.sample || el?.textContent || '€0,00'
      const value = (cents / 100).toFixed(2)
      const body = /\d,\d{2}(?!\d)/.test(sample) ? value.replace('.', ',') : value
      const symbol = (sample.match(/^[^\d]*/) || [''])[0].trim()
      return symbol ? `${symbol}${body}` : body
    }

    function render(cart) {
      if (countEl) countEl.textContent = `(${cart.item_count})`
      document.querySelectorAll('[data-cart-badge]').forEach((b) => {
        b.textContent = cart.item_count
        b.hidden = cart.item_count === 0
      })

      if (!cart.item_count) {
        body.innerHTML = ''
        foot.hidden = true
        empty.hidden = false
        return
      }

      empty.hidden = true
      foot.hidden = false
      if (subtotal) subtotal.textContent = fmt(cart.total_price)

      body.innerHTML = cart.items
        .map((item) => {
          const img = item.image
            ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" width="72" height="72" loading="lazy">`
            : `<div class="ph" style="aspect-ratio:1/1"></div>`
          const opts =
            item.options_with_values
              ?.map((o) => `${o.name}: ${o.value}`)
              .join(' · ') || ''
          const was =
            item.original_line_price > item.final_line_price
              ? `<s class="xsmall muted">${fmt(item.original_line_price)}</s>`
              : ''
          return `
            <div class="dline" data-key="${item.key}">
              <a class="dline__media" href="${item.url}">${img}</a>
              <div class="dline__info">
                <a class="dline__title" href="${item.url}">${item.product_title}</a>
                ${opts ? `<p class="xsmall muted">${opts}</p>` : ''}
                <div class="dline__qty" data-qty-row>
                  <button type="button" data-delta="-1" aria-label="${T.decrease}">−</button>
                  <span aria-live="polite">${item.quantity}</span>
                  <button type="button" data-delta="1" aria-label="${T.increase}">+</button>
                </div>
              </div>
              <div class="dline__price">
                <strong>${fmt(item.final_line_price)}</strong>
                ${was}
                <button type="button" class="dline__remove" data-remove>${T.remove}</button>
              </div>
            </div>`
        })
        .join('')
    }

    async function refresh() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      render(await res.json())
    }

    async function change(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      })
      render(await res.json())
    }

    function open() {
      lastFocus = document.activeElement
      drawer.setAttribute('data-open', '')
      drawer.setAttribute('aria-hidden', 'false')
      document.body.style.overflow = 'hidden'
      panel?.focus()
      refresh()
    }

    function close() {
      drawer.removeAttribute('data-open')
      drawer.setAttribute('aria-hidden', 'true')
      document.body.style.overflow = ''
      lastFocus?.focus()
    }

    // Bag icon opens the drawer; still a real link if JS fails earlier.
    document.querySelectorAll('.mast__cart, [data-cart-open]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        open()
      })
    })

    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) {
        if (e.target.closest('a')) return // let nav links through
        e.preventDefault()
        close()
      }

      const line = e.target.closest('.dline')
      if (!line) return
      const key = line.dataset.key

      if (e.target.closest('[data-remove]')) {
        change(key, 0)
        return
      }
      const step = e.target.closest('[data-delta]')
      if (step) {
        const qty = Number(line.querySelector('[data-qty-row] span').textContent)
        change(key, Math.max(0, qty + Number(step.dataset.delta)))
      }
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close()
    })

    // Add to bag without leaving the page.
    const productForm = document.querySelector('form[action*="/cart/add"]')
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault()
        const button = productForm.querySelector('[data-add-button]')
        const label = productForm.querySelector('[data-add-label]')
        const sticky = document.querySelector('[data-sticky-button]')
        const previous = label?.textContent
        if (button) button.disabled = true
        if (sticky) sticky.disabled = true
        if (label) label.textContent = T.adding

        // Ticked add-ons become extra lines in the same request, so the bag
        // never opens showing the device without the cover the customer chose.
        const addons = [...productForm.querySelectorAll('[data-addon-id]:checked')]

        try {
          let res
          if (addons.length) {
            const data = new FormData(productForm)
            const items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }]
            addons.forEach((a) => items.push({ id: Number(a.dataset.addonId), quantity: 1 }))

            res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            })
          } else {
            res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(productForm),
            })
          }
          if (!res.ok) throw new Error(await res.text())
          open()
        } catch {
          productForm.submit() // fall back to the real POST
          return
        } finally {
          if (button) button.disabled = false
          if (sticky) sticky.disabled = false
          if (label) label.textContent = previous
        }
      })
    }
  }


  /* Variant picker -------------------------------------------------------- */

  const money = (cents, sample) => {
    // Mirror the store's format from a rendered price, rather than assuming.
    const value = (cents / 100).toFixed(2)
    if (!sample) return '€' + value
    const usesComma = /\d,\d{2}(?!\d)/.test(sample)
    const body = usesComma ? value.replace('.', ',') : value
    const symbol = (sample.match(/^[^\d]*/) || [''])[0].trim()
    const suffix = (sample.match(/[^\d]*$/) || [''])[0].trim()
    return symbol ? `${symbol}${body}` : `${body}${suffix ? ' ' + suffix : ''}`
  }

  // Mirrors snippets/grade-data.liquid — the canonical scale.
  const BATTERY = { A: 95, B: 90, C: 85 }

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const raw = picker.querySelector('[data-variant-data]')
    if (!raw) return

    let variants
    try {
      variants = JSON.parse(raw.textContent)
    } catch {
      return // leave the form submitting server-side
    }

    const idInput = picker.querySelector('[data-variant-id]')
    const priceBlock = document.querySelector('[data-price-block]')
    const addButton = document.querySelector('[data-add-button]')
    const addLabel = document.querySelector('[data-add-label]')
    const instal = document.querySelector('[data-installments]')
    const instalAmount = document.querySelector('[data-instal-amount]')
    const specStorage = document.querySelector('[data-spec-storage]')
    const specBattery = document.querySelector('[data-spec-battery]')
    const compareRows = document.querySelectorAll('[data-grade-compare] tbody tr')
    const compareStorage = document.querySelector('[data-compare-storage]')

    // Capture the server-rendered money format before we overwrite anything.
    const sample = priceBlock?.querySelector('.price__now')?.textContent || ''

    const selection = () =>
      [...picker.querySelectorAll('.vopt__input:checked')]
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((i) => i.value)

    const findVariant = (opts) =>
      variants.find((v) => opts.every((o, i) => v.options[i] === o))

    const optionNames = [...picker.querySelectorAll('.vopt')].map((f) =>
      f.querySelector('.vopt__name')?.textContent.trim()
    )

    // Price every option against the current selection, so "what would 256 GB
    // cost me" is answered before the click rather than after it.
    function repriceOptions(opts) {
      picker.querySelectorAll('.vopt').forEach((field) => {
        const index = Number(field.dataset.optionIndex)

        field.querySelectorAll('.vopt__input').forEach((input) => {
          const target = input.nextElementSibling?.querySelector('[data-option-price]')
          if (!target) return

          const candidate = opts.map((v, i) => (i === index ? input.value : v))
          const variant = findVariant(candidate)
          const label = input.nextElementSibling

          if (!variant) {
            target.innerHTML = '<span class="muted">Unavailable</span>'
            label?.classList.add('is-unavailable')
            return
          }
          label?.classList.toggle('is-unavailable', !variant.available)

          let html = `<strong>${money(variant.price, sample)}</strong>`
          if (variant.compare_at_price > variant.price) {
            const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
            // Only the grade cards carry a saving chip; the storage pills would
            // repeat the same percentage on every option and say nothing.
            if (label?.classList.contains('gcard')) html += ` <span class="gcard__save">−${pct}%</span>`
          }
          target.innerHTML = html
        })
      })
    }

    function update() {
      const opts = selection()
      const variant = findVariant(opts)

      // Reflect each option's chosen value in its legend.
      opts.forEach((value, i) => {
        const label = picker.querySelector(`[data-option-label="${i}"]`)
        if (label) label.textContent = value
      })

      repriceOptions(opts)

      const conditionIdx = optionNames.indexOf('Condition')
      const storageIdx = optionNames.indexOf('Storage')
      // Option values read "A – Like new"; the letter is the grade.
      const grade = conditionIdx > -1 ? opts[conditionIdx]?.trim().charAt(0).toUpperCase() : null
      const storage = storageIdx > -1 ? opts[storageIdx] : null

      if (specStorage && storage) specStorage.textContent = storage
      if (specBattery && grade && BATTERY[grade]) specBattery.textContent = `${BATTERY[grade]}% min`

      // Comparison table follows the selected storage.
      if (compareRows.length && storage) {
        compareRows.forEach((row) => {
          row.hidden = row.dataset.storage !== storage && row.dataset.storage !== 'all'
          row.classList.toggle('is-current', variant && row.dataset.variant === String(variant.id))
        })
        if (compareStorage) compareStorage.textContent = `· ${storage}`
      }

      if (!variant) {
        if (addButton) addButton.disabled = true
        if (addLabel) addLabel.textContent = T.unavailable
        return
      }

      if (idInput) idInput.value = variant.id

      if (addButton) addButton.disabled = !variant.available
      if (addLabel) addLabel.textContent = variant.available ? T.addToBag : T.soldOut

      if (priceBlock) {
        const now = priceBlock.querySelector('.price__now')
        const was = priceBlock.querySelector('.price__was')
        const save = priceBlock.querySelector('.price__save')
        if (now) now.textContent = money(variant.price, sample)

        const hasCompare = variant.compare_at_price > variant.price
        if (was) {
          was.textContent = hasCompare ? money(variant.compare_at_price, sample) : ''
          was.hidden = !hasCompare
        }
        if (save) {
          if (hasCompare) {
            const diff = variant.compare_at_price - variant.price
            const pct = Math.round((diff * 100) / variant.compare_at_price)
            save.textContent = `Save ${money(diff, sample)} (${pct}%)`
            save.hidden = false
          } else {
            save.hidden = true
          }
        }
      }

      if (instalAmount && instal) {
        const months = Number(instal.dataset.months) || 12
        instalAmount.textContent = money(Math.round(variant.price / months), sample)
      }

      // Swap the main image to the render matching the chosen colour. Falls
      // back silently when a colour has no dedicated media yet.
      const mediaMapEl = document.querySelector('[data-media-map]')
      const pdpImage = document.querySelector('[data-pdp-image]')
      const colourIdx = optionNames.indexOf('Colour')
      if (mediaMapEl && pdpImage && colourIdx > -1 && opts[colourIdx]) {
        try {
          const map = JSON.parse(mediaMapEl.textContent)
          const want = `colour: ${opts[colourIdx].toLowerCase()}`
          const hit = map.find((m) => (m.alt || '').toLowerCase().startsWith(want))
          if (hit && pdpImage.src !== hit.src) {
            pdpImage.src = hit.src
            pdpImage.srcset = hit.srcset
          }
        } catch {
          /* malformed map is not worth a visible error */
        }
      }

      // Klarna caches its rendered placement, so changing the variant needs an
      // explicit refresh or the widget keeps quoting the previous price.
      const klarna = document.querySelector('[data-klarna-placement]')
      if (klarna) {
        klarna.setAttribute('data-purchase-amount', String(variant.price))
        window.Klarna?.OnsiteMessaging?.refresh?.()
      }

      // Keep the URL shareable without reloading.
      const url = new URL(window.location)
      url.searchParams.set('variant', variant.id)
      window.history.replaceState({}, '', url)
    }

    picker.addEventListener('change', (e) => {
      if (e.target.classList.contains('vopt__input')) update()
    })

    update()
  })

  /* Category rail: scroll by one viewport-width of tiles ------------------ */
  document.querySelectorAll('[data-rail]').forEach((rail) => {
    const scope = rail.closest('.crail') || document
    const step = () => {
      const tile = rail.querySelector('li')
      if (!tile) return rail.clientWidth
      const gap = parseFloat(getComputedStyle(rail).columnGap || '18')
      const per = Math.max(1, Math.floor(rail.clientWidth / (tile.offsetWidth + gap)))
      return per * (tile.offsetWidth + gap)
    }

    scope.querySelector('[data-rail-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -step(), behavior: 'smooth' })
    })
    scope.querySelector('[data-rail-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: step(), behavior: 'smooth' })
    })

    // Hide arrows when everything already fits.
    const sync = () => {
      const overflows = rail.scrollWidth > rail.clientWidth + 4
      scope.querySelectorAll('.crail__nav').forEach((b) => {
        b.style.display = overflows ? '' : 'none'
      })
    }
    sync()
    window.addEventListener('resize', sync, { passive: true })
  })

  /* Quantity steppers ----------------------------------------------------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input')
    wrap.querySelectorAll('button[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Number(input.value) + Number(btn.dataset.step)
        input.value = Math.max(Number(input.min || 1), next)
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    })
  })

  /* Product gallery ------------------------------------------------------- */

  document.querySelectorAll('[data-gallery]').forEach((gal) => {
    const slides = [...gal.querySelectorAll('[data-gallery-slide]')]
    const thumbs = [...gal.querySelectorAll('[data-gallery-thumb]')]
    if (slides.length < 2) return

    gal.dataset.enhanced = ''

    const show = (index) => {
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index)
        s.toggleAttribute('aria-hidden', i !== index)
      })
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index)
        t.setAttribute('aria-selected', String(i === index))
      })
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => show(i))

      // Left/right move between thumbnails, as a tablist should.
      thumb.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return
        e.preventDefault()
        const next = e.key === 'ArrowRight' ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length
        thumbs[next].focus()
        show(next)
      })
    })
  })

  /* Add-on running total -------------------------------------------------- */

  document.querySelectorAll('[data-addons]').forEach((group) => {
    const note = group.querySelector('[data-addons-total]')
    const amount = group.querySelector('[data-addons-amount]')
    if (!note || !amount) return

    // Reuse whatever format the server already rendered on an add-on price.
    const sample = group.querySelector('.addon__price')?.textContent || ''

    const sync = () => {
      const checked = [...group.querySelectorAll('[data-addon-price]:checked')]
      const total = checked.reduce((sum, el) => sum + Number(el.dataset.addonPrice || 0), 0)
      note.hidden = checked.length === 0
      amount.textContent = money(total, sample)
    }

    group.addEventListener('change', sync)
    sync()
  })

  /* Sticky buy bar -------------------------------------------------------- */

  const stickyBar = document.querySelector('[data-sticky-buy]')
  const buyBlock = document.querySelector('.pdp__buy')

  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    // Reveal only once the real button is off screen — a bar that overlaps the
    // control it duplicates is worse than no bar.
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0
      },
      { rootMargin: '0px 0px -80px 0px' }
    )
    observer.observe(buyBlock)

    // Keep the bar's price and label in step with the variant picker.
    const priceEl = stickyBar.querySelector('[data-sticky-price]')
    const metaEl = stickyBar.querySelector('[data-sticky-meta]')
    const btnEl = stickyBar.querySelector('[data-sticky-button]')
    const source = document.querySelector('[data-price-block] .price__now')

    if (source && priceEl) {
      const mirror = () => {
        priceEl.textContent = source.textContent
        const picker = document.querySelector('[data-variant-picker]')
        if (metaEl && picker) {
          metaEl.textContent = [...picker.querySelectorAll('.vopt__input:checked')]
            .map((i) => i.value)
            .join(' · ')
        }
        const add = document.querySelector('[data-add-label]')
        if (btnEl && add) {
          btnEl.textContent = add.textContent
          btnEl.disabled = document.querySelector('[data-add-button]')?.disabled ?? false
        }
      }
      new MutationObserver(mirror).observe(document.querySelector('[data-price-block]'), {
        subtree: true,
        childList: true,
        characterData: true,
      })
      document.querySelector('[data-variant-picker]')?.addEventListener('change', mirror)
      mirror()
    }
  }

  /* Recommendations ------------------------------------------------------- */

  document.querySelectorAll('[data-recommendations]').forEach(async (host) => {
    // Already rendered server-side? Then Shopify had them cached; leave it be.
    if (host.querySelector('[data-rail]')) return

    try {
      const res = await fetch(host.dataset.url)
      if (!res.ok) return
      const text = await res.text()
      const doc = new DOMParser().parseFromString(text, 'text/html')
      const fresh = doc.querySelector('[data-recommendations]')
      if (!fresh || !fresh.querySelector('[data-rail]')) return

      host.innerHTML = fresh.innerHTML
      bindRail(host.querySelector('[data-rail]'))
    } catch {
      /* A missing cross-sell rail is not worth a visible error. */
    }
  })

  /* Review submission ----------------------------------------------------- */

  document.querySelectorAll('[data-review-post]').forEach((form) => {
    const msg = form.querySelector('[data-review-msg]')
    const button = form.querySelector('[data-review-submit]')

    const say = (text, ok) => {
      if (!msg) return
      msg.textContent = text
      msg.hidden = false
      msg.classList.toggle('is-ok', !!ok)
      msg.classList.toggle('is-error', !ok)
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault()
      const data = new FormData(form)

      const payload = {
        product_gid: form.dataset.productGid,
        product_handle: form.dataset.productHandle,
        rating: Number(data.get('rating')),
        title: data.get('title') || '',
        body: data.get('body') || '',
        author: data.get('author') || '',
        email: data.get('email') || '',
      }

      if (!payload.rating) {
        say(T.pickRating, false)
        return
      }

      const label = button?.textContent
      if (button) {
        button.disabled = true
        button.textContent = 'Sending…'
      }

      try {
        const res = await fetch(form.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
        const out = await res.json().catch(() => ({}))

        if (res.ok) {
          form.querySelectorAll('input, textarea, button').forEach((el) => (el.disabled = true))
          say(out.message || T.reviewSent, true)
        } else {
          // The server explains why (no matching order, already reviewed); show
          // that rather than a generic failure the customer cannot act on.
          say(out.detail || T.reviewFailed, false)
        }
      } catch {
        say(T.reviewNetwork, false)
      } finally {
        if (button && !button.disabled) button.textContent = label
        else if (button) button.textContent = label
      }
    })
  })

  /* Reviews: reveal the rest --------------------------------------------- */

  document.querySelectorAll('[data-reviews-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('[data-review-extra]').forEach((r) => {
        r.hidden = false
        r.classList.remove('rev__item--hidden')
      })
      btn.closest('.rev__more')?.remove()
    })
  })

  /* Help-centre filter ---------------------------------------------------- */

  document.querySelectorAll('[data-faq-filter]').forEach((wrap) => {
    const input = wrap.querySelector('[data-faq-input]')
    const empty = wrap.querySelector('[data-faq-empty]')
    const scope = wrap.closest('section')
    if (!input || !scope) return

    const items = [...scope.querySelectorAll('[data-faq-item]')]
    const groups = [...scope.querySelectorAll('.faq__group')]

    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase()
      let hits = 0

      items.forEach((item) => {
        const text = (
          item.querySelector('[data-faq-question]')?.textContent +
          ' ' +
          item.querySelector('[data-faq-answer]')?.textContent
        ).toLowerCase()
        const match = !q || text.includes(q)
        item.hidden = !match
        if (match) hits++
        // Open matches while filtering so the answer is visible immediately.
        item.open = Boolean(q) && match
      })

      // A category heading with nothing under it is just noise.
      groups.forEach((g) => {
        g.hidden = ![...g.querySelectorAll('[data-faq-item]')].some((i) => !i.hidden)
      })

      if (empty) empty.hidden = hits > 0
    })
  })

  /* Trade-in estimator ---------------------------------------------------- */

  document.querySelectorAll('[data-tradein]').forEach((root) => {
    const raw = root.querySelector('[data-tradein-data]')
    if (!raw) return

    let devices
    try {
      devices = JSON.parse(raw.textContent)
    } catch {
      return
    }

    const deviceSel = root.querySelector('[data-ti-device]')
    const storageSel = root.querySelector('[data-ti-storage]')
    const result = root.querySelector('[data-ti-result]')
    const amountEl = root.querySelector('[data-ti-amount]')
    const contact = root.querySelector('[data-ti-contact]')
    const symbol = root.dataset.symbol || '€'

    const multiplier = (key) => Number(root.dataset['mult' + key.charAt(0).toUpperCase() + key.slice(1)] || 100) / 100

    // "128 GB: 240" per line → [{ label, value }]
    const parsePrices = (text) =>
      String(text || '')
        .split('\n')
        .map((line) => {
          const i = line.lastIndexOf(':')
          if (i < 0) return null
          const label = line.slice(0, i).trim()
          const value = Number(line.slice(i + 1).replace(/[^\d.]/g, ''))
          return label && value ? { label, value } : null
        })
        .filter(Boolean)

    const selected = (name) => root.querySelector(`[name="${name}"]:checked`)?.value

    function update() {
      const device = devices[deviceSel.value]
      if (!device) {
        result.hidden = true
        contact.hidden = true
        return
      }

      const prices = parsePrices(device.prices)
      const option = prices[storageSel.selectedIndex]
      if (!option) {
        result.hidden = true
        contact.hidden = true
        return
      }

      const condition = selected('ti-condition') || 'good'
      const works = selected('ti-works') || 'yes'

      let value = option.value * multiplier(condition)
      // A device that will not power on is a parts device whatever it looks
      // like, so the cosmetic grade stops mattering.
      if (works === 'no') value = Math.min(value, option.value * multiplier('faulty'))

      const rounded = Math.max(5, Math.round(value / 5) * 5)
      amountEl.textContent = `${symbol}${rounded}`
      result.hidden = false
      contact.hidden = false

      const set = (sel, v) => {
        const el = root.querySelector(sel)
        if (el) el.value = v
      }
      set('[data-ti-hidden-device]', device.name)
      set('[data-ti-hidden-storage]', option.label)
      set('[data-ti-hidden-condition]', condition)
      set('[data-ti-hidden-works]', works)
      set('[data-ti-hidden-estimate]', `${symbol}${rounded}`)
      set(
        '[data-ti-hidden-body]',
        `Trade-in request\n\nDevice: ${device.name}\nStorage: ${option.label}\n` +
          `Condition: ${condition}\nPowers on: ${works}\nIndicative estimate: ${symbol}${rounded}`
      )
    }

    deviceSel.addEventListener('change', () => {
      const device = devices[deviceSel.value]
      storageSel.innerHTML = ''

      if (!device) {
        storageSel.disabled = true
        storageSel.innerHTML = '<option value="">Pick a device first</option>'
        update()
        return
      }

      parsePrices(device.prices).forEach((p, i) => {
        const opt = document.createElement('option')
        opt.value = String(i)
        opt.textContent = p.label
        storageSel.append(opt)
      })
      storageSel.disabled = false
      update()
    })

    root.addEventListener('change', (e) => {
      if (e.target === deviceSel) return
      update()
    })
  })
  /* Model comparison ------------------------------------------------------ */

  document.querySelectorAll('[data-compare]').forEach((root) => {
    const raw = root.querySelector('[data-compare-data]')
    const mount = root.querySelector('[data-compare-mount]')
    const controls = root.querySelector('[data-compare-controls]')
    if (!raw || !mount) return

    let models
    try {
      models = JSON.parse(raw.textContent).filter((m) => m && m.title)
    } catch {
      return // the <noscript> table stands
    }
    if (models.length < 2) return

    const byId = new Map(models.map((m) => [String(m.id), m]))
    const lockedId = root.dataset.locked || null
    const columnCount = Math.min(Number(root.dataset.columns) || 3, models.length)

    // Preselect: the locked model, then whatever else is nearest in price —
    // the useful neighbour on a refurb catalogue is what the same money buys.
    const initial = []
    if (lockedId && byId.has(lockedId)) initial.push(lockedId)

    const anchor = initial.length ? byId.get(initial[0]) : models[0]
    models
      .filter((m) => !initial.includes(String(m.id)))
      .sort((a, b) => {
        // Same product type first, then nearest by price.
        const typeDelta = (a.type === anchor.type ? 0 : 1) - (b.type === anchor.type ? 0 : 1)
        if (typeDelta) return typeDelta
        return Math.abs(a.price - anchor.price) - Math.abs(b.price - anchor.price)
      })
      .slice(0, columnCount - initial.length)
      .forEach((m) => initial.push(String(m.id)))

    let selected = [...initial]
    let diffOnly = false
    let expanded = false

    const esc = (s) =>
      String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])

    /* Row model ----------------------------------------------------------- */

    // Union of every group and label across the selected models, in the order
    // the first model that has them declares them. A model missing a row shows
    // "—" rather than the row vanishing: on a comparison, an absent figure is
    // information, and dropping the row hides which device lacks it.
    // A product with no specs metafield yields whatever Liquid emitted; treat
    // anything that is not an array as none, so one unseeded model cannot take
    // the whole table down.
    const specsOf = (model) => (Array.isArray(model?.specs) ? model.specs : [])

    function buildGroups(chosen) {
      const groups = []
      const groupIndex = new Map()

      chosen.forEach((model) => {
        specsOf(model).forEach((group) => {
          let g = groupIndex.get(group.group)
          if (!g) {
            g = { name: group.group, labels: [], seen: new Set() }
            groupIndex.set(group.group, g)
            groups.push(g)
          }
          ;(group.rows || []).forEach((row) => {
            if (!g.seen.has(row.label)) {
              g.seen.add(row.label)
              // `key` marks the rows that decide between two devices. Set in
              // scripts/spec-data.mjs, so the judgement lives with the data.
              g.labels.push({ label: row.label, key: Boolean(row.key) })
            } else if (row.key) {
              // Any model calling a row key makes it key for the whole table —
              // otherwise the same row would appear or vanish depending on
              // which column happened to be first.
              const existing = g.labels.find((l) => l.label === row.label)
              if (existing) existing.key = true
            }
          })
        })
      })

      return groups
    }

    const valueFor = (model, groupName, label) => {
      const group = specsOf(model).find((g) => g.group === groupName)
      const row = group?.rows?.find((r) => r.label === label)
      return row ? row.value : null
    }

    const allSame = (values) => {
      const normalised = values.map((v) => (v == null ? '' : String(v).trim()))
      return normalised.every((v) => v === normalised[0])
    }

    /* Render -------------------------------------------------------------- */

    function picker(columnIndex, currentId) {
      const isLocked = lockedId && columnIndex === 0
      if (isLocked) return ''

      const options = models
        .map((m) => {
          // A model already in another column cannot be picked twice.
          const takenElsewhere = selected.includes(String(m.id)) && String(m.id) !== currentId
          return `<option value="${esc(m.id)}"${String(m.id) === currentId ? ' selected' : ''}${
            takenElsewhere ? ' disabled' : ''
          }>${esc(m.title)}</option>`
        })
        .join('')

      return `<select class="input cmp__picker" data-compare-select="${columnIndex}" aria-label="Model for column ${
        columnIndex + 1
      }">${options}</select>`
    }

    function render() {
      const chosen = selected.map((id) => byId.get(id)).filter(Boolean)
      if (!chosen.length) return

      const groups = buildGroups(chosen)

      const head = chosen
        .map((m, i) => {
          const locked = lockedId && i === 0
          const img = m.image
            ? `<img src="${esc(m.image)}" alt="" width="96" height="96" loading="lazy">`
            : '<span class="ph" style="aspect-ratio:1/1"></span>'
          return `
            <th scope="col" class="cmp__col${locked ? ' cmp__col--current' : ''}">
              <a class="cmp__ident" href="${esc(m.url)}">
                ${img}
                <span class="cmp__name">${esc(m.title)}</span>
              </a>
              ${locked ? '<span class="cmp__flag">You’re viewing</span>' : picker(i, String(m.id))}
            </th>`
        })
        .join('')

      const headline = [
        {
          label: 'Price from',
          cells: chosen.map((m) => {
            const was = m.compareText ? `<s class="cmp__was">${esc(m.compareText)}</s>` : ''
            const save = m.save ? `<span class="cmp__save">−${m.save}%</span>` : ''
            return `<strong class="cmp__price">${esc(m.priceText)}</strong> ${was} ${save}`
          }),
          always: true,
        },
        {
          label: 'Rating',
          cells: chosen.map((m) =>
            m.rating ? `${Number(m.rating).toFixed(1)} / 5 <span class="muted">(${m.ratingCount})</span>` : '—'
          ),
        },
        {
          label: 'Grades available',
          cells: chosen.map((m) => (m.grades?.length ? m.grades.join('<br>') : '—')),
        },
        {
          label: 'Storage options',
          cells: chosen.map((m) => (m.storages?.length ? m.storages.join(' · ') : '—')),
        },
        {
          label: 'In stock',
          cells: chosen.map((m) => (m.available ? 'Yes' : 'No')),
        },
      ]

      const rowHtml = (label, cells, always) => {
        const same = allSame(cells.map((c) => String(c)))
        if (diffOnly && same && !always) return ''
        return `
          <tr${same ? ' data-same' : ''}>
            <th scope="row">${esc(label)}</th>
            ${cells
              .map((c, i) => `<td${lockedId && i === 0 ? ' class="cmp__col--current"' : ''}>${c ?? '—'}</td>`)
              .join('')}
          </tr>`
      }

      const headlineRows = headline.map((r) => rowHtml(r.label, r.cells, r.always)).join('')

      // Collapsed by default: only the rows that decide between two devices.
      // Forty rows is a wall, and a wall gets skipped rather than read.
      let hiddenCount = 0

      const specRows = groups
        .map((group) => {
          const visible = group.labels.filter((l) => {
            if (expanded || l.key) return true
            hiddenCount++
            return false
          })

          const rows = visible
            .map((l) =>
              rowHtml(
                l.label,
                chosen.map((m) => valueFor(m, group.name, l.label) || '—')
              )
            )
            .join('')

          if (!rows.trim()) return ''
          return `
            <tr class="cmp__grouprow">
              <th scope="colgroup" colspan="${chosen.length + 1}">${esc(group.name)}</th>
            </tr>${rows}`
        })
        .join('')

      const totalRows = groups.reduce((n, g) => n + g.labels.length, 0)
      const more = hiddenCount
        ? `<tr class="cmp__morerow">
             <th scope="row"><span class="visually-hidden">More</span></th>
             <td colspan="${chosen.length}">
               <button type="button" class="cmp__more" data-compare-expand>
                 Show all ${totalRows} specifications
               </button>
             </td>
           </tr>`
        : expanded
          ? `<tr class="cmp__morerow">
               <th scope="row"><span class="visually-hidden">Less</span></th>
               <td colspan="${chosen.length}">
                 <button type="button" class="cmp__more" data-compare-expand>Show key specifications only</button>
               </td>
             </tr>`
          : ''

      const cta = `
        <tr class="cmp__cta">
          <th scope="row"><span class="visually-hidden">Link</span></th>
          ${chosen
            .map((m, i) =>
              lockedId && i === 0
                ? '<td class="cmp__col--current"><span class="small muted">This page</span></td>'
                : `<td><a class="btn btn--outline btn--sm" href="${esc(m.url)}">View</a></td>`
            )
            .join('')}
        </tr>`

      mount.innerHTML = `
        <table class="cmp__table">
          <caption class="visually-hidden">${esc(chosen.map((m) => m.title).join(' compared with '))}</caption>
          <thead><tr><th scope="col" class="cmp__corner"><span class="visually-hidden">Specification</span></th>${head}</tr></thead>
          <tbody>${headlineRows}${specRows}${more}${cta}</tbody>
        </table>`

      mount.hidden = false
      if (controls) controls.hidden = false
    }

    mount.addEventListener('change', (e) => {
      const select = e.target.closest('[data-compare-select]')
      if (!select) return
      selected[Number(select.dataset.compareSelect)] = select.value
      render()
    })

    mount.addEventListener('click', (e) => {
      if (!e.target.closest('[data-compare-expand]')) return
      expanded = !expanded

      // Re-rendering throws away scroll position; hold the table's top edge
      // still so expanding does not fling the reader up the page.
      const before = mount.getBoundingClientRect().top
      render()
      window.scrollBy(0, mount.getBoundingClientRect().top - before)
    })

    controls?.querySelector('[data-compare-diff]')?.addEventListener('change', (e) => {
      diffOnly = e.target.checked
      render()
    })

    controls?.querySelector('[data-compare-reset]')?.addEventListener('click', () => {
      selected = [...initial]
      diffOnly = false
      expanded = false
      const box = controls.querySelector('[data-compare-diff]')
      if (box) box.checked = false
      render()
    })

    render()
  })

  /* Rail binding, shared by server-rendered and fetched carousels ---------- */
  // Declared last but hoisted, so the recommendations handler above can call it.
  function bindRail(rail) {
    if (!rail) return
    const scope = rail.closest('.crail') || document
    const step = () => {
      const tile = rail.querySelector('li')
      if (!tile) return rail.clientWidth
      const gap = parseFloat(getComputedStyle(rail).columnGap || '18')
      const per = Math.max(1, Math.floor(rail.clientWidth / (tile.offsetWidth + gap)))
      return per * (tile.offsetWidth + gap)
    }
    scope.querySelector('[data-rail-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -step(), behavior: 'smooth' })
    })
    scope.querySelector('[data-rail-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: step(), behavior: 'smooth' })
    })
  }
})()
